import GlobalErrorFallback from 'contexts/error-handler/global-error-fallback';
import React from 'react';
import { addDatadogRumError } from 'utils/datadog-rum';

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
};



class AppErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    addDatadogRumError(error, {
      source: 'react-error-boundary',
      componentStack: errorInfo.componentStack
    });
  }

  private handleRetry = (): void => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return <GlobalErrorFallback onRetry={this.handleRetry} />;
    }
    return this.props.children;
  }
}
export default AppErrorBoundary;